import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    mobileContainer: 'h-full w-full',
    base: 'flex h-full w-full flex-col bg-white lg:w-100 lg:shadow-[0px_0px_12px_0px_rgba(0,0,0,0.07)] xl:w-105 xl:p-5',
    title: 'heading-xl',
    pointTypeSelector: 'relative mb-3 md:mt-3 md:mb-4',
    pointsScrollWrapper: '',
    pointsScrollInner: 'relative w-full',
    pointList: 'top-0 left-0 w-full lg:absolute',
    pointItemContainer:
      'w-full border-t-[1px] border-black pt-2 first:border-0 first:pt-0',
    pointItem:
      'bg-bg-items-white/40 w-full cursor-pointer p-5 text-left transition-colors',
    pointTitle: 'heading-m-bold',
    pointAddress: 'heading-s mt-2',
    pointCost: 'heading-s mt-2',
    pointDeliveryDate: 'heading-s mt-1',
    pointHeading: 'heading-s mt-3',
    pointValue: 'heading-s mt-2',
    pointConfirm: 'mt-5 w-full',
    emptyState: 'text-m',
    info: 'bg-surface mt-3 mb-6 flex h-12 min-h-12 items-center justify-between rounded-full px-5 lg:mb-4',
    btn: 'heading-m-regular flex h-6 items-center p-0',
    btnRow: 'flex items-center gap-1',
    btnIcon: 'group-pressed:-scale-100 rotate-90 transition-transform duration-150',
    size: 'heading-s',
    sizeRow: 'flex items-end gap-2'
  },
  variants: {
    isActive: {
      true: {
        pointItem: 'bg-bg-items-white',
        pointItemContainer: 'bg-surface'
      }
    },
    type: {
      simple: {
        base: 'md:p-5'
      },
      pdp: {
        base: 'px-2 py-3.5 md:p-6',
        mobileContainer: 'max-lg:container',
        pointItemContainer: 'hover:bg-surface'
      }
    },
    isScroll: {
      true: {
        pointsScrollWrapper: 'h-full overflow-y-auto lg:contain-strict'
      }
    }
  },
  compoundVariants: [
    {
      type: 'simple',
      isActive: true,
      className: {
        pointItem: 'bg-surface'
      }
    }
  ]
});
